import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ReactComponent as IconSearch } from '~/assets/images/token-search.svg'
import { ReactComponent as IconClear } from '~/assets/images/close-circle.svg'

interface Props {
  searchText: string
  setSearchText: (text: string) => void
}
const SearchBar: React.FC<Props> = ({ searchText, setSearchText }) => {
  const { t } = useTranslation()

  return (
    <StyledSearchBar>
      <StyledSearchIcon />
      <StyledSearchInput
        placeholder={t('search_token')}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      {searchText && <StyledClearIcon onClick={() => setSearchText('')} />}
    </StyledSearchBar>
  )
}

export default SearchBar

const StyledSearchBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0 10px 15px;
  background: #fff;
`

const StyledSearchInput = styled.input`
  border: 0.5px solid #eaecf6;
  border-radius: 42px;
  padding: 12px 10px 12px 33px;
  padding-right: 35px;
  font-size: 13px;
  line-height: 16px;
  width: 100%;
  outline: none;
  background: rgb(250, 250, 252);

  &:focus,
  &:hover {
    box-shadow: 0 0 2px rgba(95, 77, 188, 0.2);
  }
`

const StyledSearchIcon = styled(IconSearch)`
  position: absolute;
  left: 21px;
  top: 11px;
`

const StyledClearIcon = styled(IconClear)`
  position: absolute;
  right: 21px;
  top: 11px;
  cursor: pointer;
`
